// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-container {
  max-width: 1200px;
  margin: 2rem auto;
  padding: 1rem;
  color: #2b1d0f;
}

.checkout-container h1 {
  text-align: center;
  margin-bottom: 2rem;
}

.checkout-content {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
}

.checkout-form {
  flex: 1 1;
  min-width: 300px;
  background: #f5e6d3;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.checkout-form h2,
.checkout-form h3 {
  margin-bottom: 1rem;
}

.checkout-form input,
.checkout-form select {
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid #d2a556;
  border-radius: 6px;
  font-size: 1rem;
}

.place-order-btn {
  width: 100%;
  padding: 0.75rem;
  background: #d2a556;
  border: none;
  border-radius: 6px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.place-order-btn:hover {
  background: #b58e3f;
}

.order-summary {
  flex: 1 1;
  min-width: 300px;
  background: #fef7ed;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.order-summary h2 {
  margin-bottom: 1.5rem;
}

.summary-item {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  align-items: center;
}

.summary-item img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
}

.summary-item p {
  margin: 0;
  font-weight: bold;
}

.summary-item span {
  display: block;
  font-size: 0.9rem;
  color: #5a3e1b;
}
.success-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  background: #f6fff6;
}

.success-box {
  text-align: center;
  padding: 40px;
  border-radius: 12px;
  background: white;
  border: 2px solid #4caf50;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  animation: pop 0.4s ease;
}

.success-box h1 {
  color: #2e7d32;
}

@keyframes pop {
  from {
    transform: scale(0.85);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.spinner {
  width: 45px;
  height: 45px;
  border: 5px solid #ddd;
  border-top: 5px solid #4caf50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 15px;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

.success-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  background: #f6fff6;
}

.success-box {
  text-align: center;
  padding: 40px;
  border-radius: 12px;
  background: white;
  border: 2px solid #4caf50;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  animation: pop 0.3s ease;
}

@keyframes pop {
  from {
    transform: scale(0.85);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.overlay-box {
  background: white;
  padding: 40px;
  border-radius: 12px;
  text-align: center;
  width: 320px;
}

.overlay-box.success {
  border: 2px solid #4caf50;
}

.spinner {
  width: 45px;
  height: 45px;
  border: 5px solid #ddd;
  border-top: 5px solid #4caf50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 15px;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/checkoutPage/checkout.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".checkout-container {\n  max-width: 1200px;\n  margin: 2rem auto;\n  padding: 1rem;\n  color: #2b1d0f;\n}\n\n.checkout-container h1 {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.checkout-content {\n  display: flex;\n  gap: 2rem;\n  flex-wrap: wrap;\n}\n\n.checkout-form {\n  flex: 1;\n  min-width: 300px;\n  background: #f5e6d3;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.checkout-form h2,\n.checkout-form h3 {\n  margin-bottom: 1rem;\n}\n\n.checkout-form input,\n.checkout-form select {\n  width: 100%;\n  padding: 0.75rem;\n  margin-bottom: 1rem;\n  border: 1px solid #d2a556;\n  border-radius: 6px;\n  font-size: 1rem;\n}\n\n.place-order-btn {\n  width: 100%;\n  padding: 0.75rem;\n  background: #d2a556;\n  border: none;\n  border-radius: 6px;\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.place-order-btn:hover {\n  background: #b58e3f;\n}\n\n.order-summary {\n  flex: 1;\n  min-width: 300px;\n  background: #fef7ed;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.order-summary h2 {\n  margin-bottom: 1.5rem;\n}\n\n.summary-item {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  align-items: center;\n}\n\n.summary-item img {\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: 6px;\n}\n\n.summary-item p {\n  margin: 0;\n  font-weight: bold;\n}\n\n.summary-item span {\n  display: block;\n  font-size: 0.9rem;\n  color: #5a3e1b;\n}\n.success-screen {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80vh;\n  background: #f6fff6;\n}\n\n.success-box {\n  text-align: center;\n  padding: 40px;\n  border-radius: 12px;\n  background: white;\n  border: 2px solid #4caf50;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n  animation: pop 0.4s ease;\n}\n\n.success-box h1 {\n  color: #2e7d32;\n}\n\n@keyframes pop {\n  from {\n    transform: scale(0.85);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.spinner {\n  width: 45px;\n  height: 45px;\n  border: 5px solid #ddd;\n  border-top: 5px solid #4caf50;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 15px;\n}\n\n@keyframes spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.success-screen {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80vh;\n  background: #f6fff6;\n}\n\n.success-box {\n  text-align: center;\n  padding: 40px;\n  border-radius: 12px;\n  background: white;\n  border: 2px solid #4caf50;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n  animation: pop 0.3s ease;\n}\n\n@keyframes pop {\n  from {\n    transform: scale(0.85);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.overlay-box {\n  background: white;\n  padding: 40px;\n  border-radius: 12px;\n  text-align: center;\n  width: 320px;\n}\n\n.overlay-box.success {\n  border: 2px solid #4caf50;\n}\n\n.spinner {\n  width: 45px;\n  height: 45px;\n  border: 5px solid #ddd;\n  border-top: 5px solid #4caf50;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 15px;\n}\n\n@keyframes spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
